// Software built by  Adeweb Developer Africa
// portfolio website: https://adeweb-developer.vercel.app
// whatsApp Message: https://wa.me/23407043455416
// I am open for your software development gig, thank you

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB6ALWFHWuhuStBmkE5SthqhFua5ALSg0s",
  authDomain: "ikorodu-dating-site.firebaseapp.com",
  projectId: "ikorodu-dating-site",
  storageBucket: "ikorodu-dating-site.appspot.com",
  messagingSenderId: "1007372063529",
  appId: "1:1007372063529:web:8bc722068ac9eb8f945d38",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const googleProvider = new GoogleAuthProvider();

export { auth, db, storage, googleProvider };
